import React, { useState } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

type LanguageSelectionProps = {
  onLanguageSelect: (language: string) => void;
};

export const LanguageSelection: React.FC<LanguageSelectionProps> = ({
  onLanguageSelect,
}) => {
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>("en");

  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    const newLanguage = event.target.value as string;
    setSelectedLanguage(newLanguage);
  };

  const handleSubmit = () => {
    onLanguageSelect(selectedLanguage);
  };

  return (
    <Box
      sx={{
        padding: 3,
        pb: 6,
        maxWidth: 450,
        height: "calc(100vh - 190px)",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img src="/logo.png" alt="Logo" style={{ height: 230 }} />
      <Typography variant="h6" mb={3} gutterBottom textAlign={"center"}>
        {t("survey.languageSelection.title")}
        <br /> {t("survey.languageSelection.subtitle")}
      </Typography>
      <FormControl fullWidth>
        <Select
          labelId="language-select-label"
          value={selectedLanguage}
          onChange={handleLanguageChange}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="tr">Türkçe</MenuItem>
          <MenuItem value="es">Español</MenuItem>
          <MenuItem value="fr">Français</MenuItem>
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        sx={{ my: 2 }}
        onClick={handleSubmit}
      >
        {t("survey.languageSelection.continue")}
      </Button>
    </Box>
  );
};
